// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "tr[data-v-279dd56b]{border-bottom:none!important}tr td[data-v-279dd56b]{border-bottom:5px solid #fff!important}tr:last-child td[data-v-279dd56b]{border-bottom:none!important}td.shrunk[data-v-279dd56b],th.shrunk[data-v-279dd56b]{width:1px;white-space:nowrap}.vertical-align-top[data-v-279dd56b]{vertical-align:top}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
